export const product = [
  'ALL Mobil Super™ All-In-One Protection (3.5L)',
  'ALL Mobil Super™ All-In-One Protection (4L)',
  'Mobil Super™ Friction Fighter 10W40 (4L)',
  'Mobil Super™ Friction Fighter 5W30 (4L)'
]
